import { render, staticRenderFns } from "./ImprimBookFooter.vue?vue&type=template&id=57b0dbf8&scoped=true&"
import script from "./ImprimBookFooter.vue?vue&type=script&lang=js&"
export * from "./ImprimBookFooter.vue?vue&type=script&lang=js&"
import style0 from "./ImprimBookFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ImprimBookFooter.vue?vue&type=style&index=1&id=57b0dbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b0dbf8",
  null
  
)

export default component.exports